var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.assessments.length > 1)?_c('div',{attrs:{"id":"select-assessment"}},[_c('form-select',{attrs:{"value":_vm.assessment,"items":_vm.assessments,"dense":"","hide-details":"","height":"36","attach":"#select-assessment","menu-props":{
      width: '100%',
      offsetY: true,
      contentClass: 'custom-select-menu custom-select-menu--dense'
    }},on:{"change":function($event){return _vm.setAssess($event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }